import SupervisorList from "./pages/ListPage.vue";
import SupervisorDetail from "./pages/FormPage.vue";
import SupervisorIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/supervisor",
    component: SupervisorIndex,
    redirect: "/supervisor/list",
    name: "supervisor",
    children: [
      {
        path: "list",
        component: SupervisorList,
        name: "supervisor.list",
      },
      {
        path: "create",
        component: SupervisorDetail,
        name: "supervisor.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: SupervisorDetail,
        name: "supervisor.edit",
        props: { create: false },
      },
    ],
  },
];
